const handleDate = date => {
    let _date = date.split(' ');
    return _date[0].split('-').reverse().join('/') + " " + _date[1].slice(0, -3);
};

export default function DataHandler(data) {
    return data.map(item => (
        {
            identifier: item.identifier,
            cardNumber: item.responseCielo.Payment.CreditCard.CardNumber,
            holder: item.responseCielo.Payment.CreditCard.Holder,
            brand: item.responseCielo.Payment.CreditCard.Brand,
            tid: item.responseCielo.Payment.Tid,
            proof: item.responseCielo.Payment.ProofOfSale,
            code: item.responseCielo.Payment.AuthorizationCode,
            provider: item.responseCielo.Payment.Provider,
            id: item.responseCielo.Payment.PaymentId,
            amount: item.responseCielo.Payment.Amount.toString().replace(/\d{2}$/, e => "." + e),
            date: handleDate(item.responseCielo.Payment.ReceivedDate),
            installments: item.responseCielo.Payment.Installments,
            reversal: item.reversal
        }
    ));
}



// WEBPACK FOOTER //
// ./src/views/Cielo/Transactions/DataHandler.js